import { newsConstants } from '../constants/news';

const initialState = {
  promotions: [],
  news: [],
  newsTotal: 0,
  myNews: [],
  myNewsTotal: 0,
  myPromotions: [],
  selected: {},
  newOffersNews: [],
  newOffersNewsTotal: 0,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case newsConstants.SET_NEWS_LIST_SUCCESS:
      return {
        ...state,
        news: action.news,
        newsTotal: action.total,
      };
      
    case newsConstants.SET_NEWS_PROMO_SUCCESS:
      return {
        ...state,
        promotions: [...state.promotions, ...action.promotions]
      };

    case newsConstants.RESET_NEWS_PROMO:
      return {
        ...state,
        promotions: []
      }

    case newsConstants.SET_MY_NEWS_LIST_SUCCESS:
      return {
        ...state,
        myNews: action.news,
        myNewsTotal: action.total,
      };

    case newsConstants.SET_MY_NEWS_PROMO_SUCCESS:
      return {
        ...state,
        myPromotions: [...state.myPromotions, ...action.promotions]
      };

    case newsConstants.RESET_MY_NEWS_PROMO:
      return {
        ...state,
        myPromotions: []
      }

    case newsConstants.SET_NEWS_SUCCESS:
      return {
        ...state,
        selected: action.news,
      };

      case newsConstants.SET_NEW_OFFERS_NEWS_SUCCESS:
      return {
        ...state,
        newOffersNews: action.news,
        newOffersNewsTotal: action.total,
      };
    default:
      return state;
  }
};
